import { TextField as MuiTextField } from '@mui/material';

import { ITextFieldProps } from './types';

/**
 * Wrapper over the [MUI Text field](https://mui.com/material-ui/react-text-field/) component rendered in `outlined` variant
 * 
 * This component currently has two variants:
 - Default props: Label is elevated when focused or filled
 - `showElevated=false`: Label is hidden when focused or filled, i.e. rendered as `input` placeholder
 */

export const TextField = ({
  variant = 'outlined',
  showElevatedLabel = true,
  label,
  children,
  ...rest
}: ITextFieldProps) => {
  let fieldLabel = label,
    fieldPlaceholder = undefined;

  // input placeholder is used when elevated label is not required
  if (!showElevatedLabel) {
    fieldLabel = undefined;
    fieldPlaceholder = label;
  }

  return (
    <MuiTextField
      fullWidth
      variant={variant}
      label={fieldLabel}
      placeholder={fieldPlaceholder}
      {...rest}
    >
      {children}
    </MuiTextField>
  );
};
